import React from 'react';

import {
  ModalBackground,
  ModalContainer,
  ModalContent,
  BlackBamCloseIcon,
  WhiteBamCloseIcon,
} from './ModalLayout.style';

export interface ModalProps {
  isOpen?: boolean;
  onClose?: (event: React.MouseEvent<Element, MouseEvent>) => void;
  bamOnlineStyle?: boolean;
  children: React.ReactNode;
}

export const ModalLayout: React.FunctionComponent<ModalProps> = ({
  isOpen,
  onClose,
  children,
  bamOnlineStyle = false,
}) => {
  const CloseIcon = bamOnlineStyle ? BlackBamCloseIcon : WhiteBamCloseIcon;

  return (
    <ModalBackground isOpen={isOpen} onClick={onClose} bamOnlineStyle={bamOnlineStyle}>
      <ModalContainer
        bamOnlineStyle={bamOnlineStyle}
        isOpen={isOpen}
        onClick={(event) => {
          event.stopPropagation();
        }}
      >
        {onClose && <CloseIcon onClick={onClose} />}
        <ModalContent>{children}</ModalContent>
      </ModalContainer>
    </ModalBackground>
  );
};
